/* tslint:disable */
/* eslint-disable */
export enum WorkProjectAdvisorSourceEnum {
  LoggedInUser = 'LOGGED_IN_USER',
  PreviousProjectUser = 'PREVIOUS_PROJECT_USER',
  ContactUser = 'CONTACT_USER',
  FixedUser = 'FIXED_USER'
}
